'use strict';

var React = require('react');
var styleHelper = require('../../helper/styleHelper');
var graphicsHelper = require('./../../helper/graphicsHelper');
var propConst = require('../../constants/propConst');

/**
 * 水平分割条
 */
var HorizontalRule = React.createClass({

  render: function () {
    var width = styleHelper.getWidth(this.props);
    var height = styleHelper.getHeight(this.props);
    return (
      <div>
        <canvas
          ref="canvas"
          style={{width:'100%',height:'100%', position: 'absolute'}}
          onChange={this.paint.bind(this, this.props)}
          width={width}
          height={height}/>
      </div>
    );
  },

  componentDidMount: function() {
    this.paint();
  },

  componentDidUpdate: function() {
    //this.paint();
  },

  paint: function () {
    var canvas = ReactDOM.findDOMNode(this.refs.canvas);
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var dashMode = styleHelper.parseDashMode(styleHelper.getPropertyValue(this.props, propConst.DASH_MODE));
    var lineWidth = styleHelper.getBorderWidth(this.props);
    var strokeColor = styleHelper.getBackgroundColor(this.props);
    var y = (parseInt(h/2, 10) || 6) + (lineWidth % 2 === 0 ? 0 : 0.5);
    var ctx = canvas.getContext('2d');
    var ratio = graphicsHelper.applyDeviceRatio(ctx,w,h);
    w *= ratio;
    h *= ratio;
    y *= ratio;
    lineWidth *= ratio;
    //ctx.clearRect(0, 0, w, h);
    graphicsHelper.clearRect(ctx);
    graphicsHelper.drawLine(ctx, {
      dashMode: dashMode,
      lineWidth: lineWidth,
      strokeColor: strokeColor,
      startX: 0,
      startY: y,
      endX: w,
      endY: y
    })

  },
});

module.exports = HorizontalRule;



// WEBPACK FOOTER //
// ./src/views/Components/HorizontalRule.jsx